<div *ngIf="gruposItensDto?.length === 0" class="text-muted text-center p-3">
    <h5>
        Nenhuma categoria cadastrada. Para começar, acesse Configurações no menu Projeto e adicione novas categorias de
        orçamento.
    </h5>
</div>
<div *ngFor="let grupo of gruposItensDto; let i = index">
    <div>
        <button data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBackdrop" aria-controls="offcanvasWithBackdrop"
            (click)="openScroll(Scrollcontent, grupo.nome!, grupo.tipoDeCalculo!, grupo.id!)" type="button"
            class="btn btn-sm btn-soft-secondary waves-effect waves-light">Adicionar Novo | <strong>{{ grupo.nome |
                titlecase }} {{ grupo.tipoDeCalculo }}</strong></button>

    </div>
    <!-- Tabela de Itens -->
    <div class="col-xl-12">
        <div class="card">
            <div class="card-body p-1">
                <div class="table-responsive">
                    <table *ngIf="grupo.itensOrcamentos" class="table table-sm m-0 table-striped">
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th *ngIf="grupo.tipoDeCalculo === 1 || grupo.tipoDeCalculo === 3">Quantidade</th>
                                <th *ngIf="grupo.tipoDeCalculo === 2">Dias</th>
                                <th *ngIf="grupo.tipoDeCalculo === 2">Pessoas</th>
                                <th>V. Unit</th>
                                <th>Total</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of grupo.itensOrcamentos; let j = index">
                                @if(item.sobrepor){
                                <td class="d-flex align-items-center">

                                        <div class="font-size-22 text-success me-1" title="Sobrepor">
                                            <i class="bx bx-up-arrow-circle"></i>
                                        </div>
                                        {{ item.item || '' }}
                                        
                                    </td>
                                }@else{
                                    <td>{{ item.item || '' }}</td>
                                }
                                <td *ngIf="grupo.tipoDeCalculo === 1 || grupo.tipoDeCalculo === 3">{{ item.quantidade }}</td> 
                                <td *ngIf="grupo.tipoDeCalculo === 2">{{ item.quantidadeDeDia }}</td> 
                                <td *ngIf="grupo.tipoDeCalculo === 2">{{ item.quantidadePessoa }}</td> 
                                <td>R$ {{ item.valorUnitario | currency:'BRL':'':'1.2-2' }}</td>
                                <td>R$ {{ item.total | currency:'BRL':'':'1.2-2' }}</td>
                                <td style="width: 100px">
                                    <a (click)="openScroll(Scrollcontent, grupo.nome!, grupo.tipoDeCalculo!, grupo.id!, item)"
                                        class="btn btn-outline-secondary btn-sm edit me-2" title="Editar">
                                        <i class="fas fa-pencil-alt"></i>
                                    </a>
                                    <a (click)="onDeletarItem(item)" class="btn btn-outline-danger btn-sm edit"
                                        title="Excluir">
                                        <i class="fas fa-trash-alt"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="getItens(i)?.controls!.length === 0" class="text-muted text-center p-3">
                        Nenhum item adicionado.
                    </div>
                    <div class="text-nowrap p-1" style="display: flex; justify-content: end;">
                        <span class="ms-2 me-2 text-muted font-size-13">Total:</span>
                        @if(grupo.valorTotal != undefined && grupo.valorTotal){
                        <span class="badge bg-success-subtle text-success font-size-13">
                            +R$ {{ grupo.valorTotal | number:'1.2-2' }}
                        </span>
                        }@else {
                        <span class="badge bg-secondary-subtle text-light font-size-13">
                            R$ {{ grupo.valorTotal | number:'1.2-2' }}
                        </span>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #Scrollcontent let-offcanvas>
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasWithBackdropLabel">{{objetoParaCanvan.nomeCategoria}}</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
        <div class="card-body">
            <form #itemForm="ngForm" (ngSubmit)="salvarItem(itemForm)">
                <input hidden [(ngModel)]="formItemId" name="formItemId">
                <div class="row">

                    <div class="col-md-3">
                        <div class="mb-3 position-relative">
                            <label class="form-label" for="item">Item</label>
                            <select [(ngModel)]="itemSelecionado" 
                                name="itemSelecionado"
                                class="form-select form-select-sm" id="item" (change)="onItemChange($event)">

                                <option [attr.data-nome]="item.nome" [attr.data-valor-unitario]="item.valor"
                                    [attr.data-metro-quadrado]="item.metroQuadrado"
                                    *ngFor="let item of obterItensDoGrupoAtual()" [value]="item.id">
                                    {{ item.nome }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div *ngIf="objetoParaCanvan.tipoDeCalculo != 2" class="col-md-1">
                        <div class="mb-3 position-relative">
                            <label class="form-label">Quantidade</label>
                            <input [(ngModel)]="formQuantidade" name="formQuantidade"
                                (ngModelChange)="calcularValorTotal()" oninput="this.value = Math.abs(this.value)"
                                min="0" type="number" class="form-control form-control-sm" placeholder="0" min="1"
                                [readonly]="objetoParaCanvan.tipoDeCalculo === 3">
                        </div>
                    </div>

                    <div *ngIf="objetoParaCanvan.tipoDeCalculo === 2" class="col-md-1">
                        <div class="mb-3 position-relative">
                            <label class="form-label">Dias</label>
                            <input [(ngModel)]="formQuantidadeDia" name="formQuantidadeDia"
                                (ngModelChange)="calcularValorTotal()" min="0"
                                oninput="this.value = Math.abs(this.value)" type="number"
                                class="form-control form-control-sm" placeholder="0" min="1">
                        </div>
                    </div>

                    <div *ngIf="objetoParaCanvan.tipoDeCalculo === 2" class="col-md-2">
                        <div class="mb-3 position-relative">
                            <label class="form-label">Pessoas</label>
                            <input [(ngModel)]="formQuantidadePessoa" (ngModelChange)="calcularValorTotal()"
                                name="formQuantidadePessoa" min="0" oninput="this.value = Math.abs(this.value)"
                                type="number" class="form-control form-control-sm" placeholder="0" min="1">
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="mb-3 position-relative">
                            <label class="form-label">V. Unit</label>
                            <input [(ngModel)]="formValorUnitario" name="formValorUnitario"
                                (ngModelChange)="calcularValorTotal()" type="text" placeholder="0"
                                [value]="valorUnitarioSelecionado | currency:'BRL':'':'1.2-2'" readonly
                                class="form-control form-control-sm">
                        </div>
                    </div>

                    <div *ngIf="objetoParaCanvan.tipoDeCalculo == 3" class="col-md-1">

                        <label class="form-label">Sobrepor</label>
                        <div class="d-flex">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="formRadios2" name="sobreporRadio"
                                    [(ngModel)]="formSobrepor" value="1" (ngModelChange)="recalcularQuantidadePorSobrepor()">
                                <label class="form-check-label" for="formRadios2">
                                    S
                                </label>
                            </div>
                            <div class="form-check ms-3">
                                <input class="form-check-input" type="radio" id="formRadios1" name="sobreporRadio"
                                    [(ngModel)]="formSobrepor" value="0" (ngModelChange)="recalcularQuantidadePorSobrepor()" checked>
                                <label class="form-check-label" for="formRadios1">
                                    N
                                </label>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-1">
                        <div class="mb-3 position-relative">
                            <label class="form-label">Total</label>
                            <h5 class="font-size-14 pb-1">R$ {{ formValorTotal | currency:'BRL':'':'1.2-2' }}</h5>
                        </div>
                    </div>
                    <div class="col-2 mt-3">

                        @if(isLoading){
                        <button type="button" class="btn btn-success waves-effect waves-light">
                            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> registrando
                        </button>
                        }@else{
                        <button [disabled]="itemForm.invalid" type="submit"
                            class="btn btn-soft-success waves-effect waves-light">{{ nomeAcaoBotao }}</button>
                        }

                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>